var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    stroke: "#6B7280",
    strokeWidth: 1.6,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 6.667A2.667 2.667 0 0 1 6.667 4h4.372c.574 0 1.083.367 1.265.912l1.997 5.99c.21.63-.075 1.318-.669 1.615l-3.01 1.505a14.722 14.722 0 0 0 7.356 7.355l1.505-3.01a1.334 1.334 0 0 1 1.614-.668l5.991 1.997c.545.182.912.691.912 1.265v4.372A2.667 2.667 0 0 1 25.333 28H24C12.954 28 4 19.046 4 8V6.667"
  })));
};
export default SvgPhone;